/**
 * The sensors of new-hardware nodes (the AP node and relayed sensors). The numbers are the API's <c>SensorType</c> values: they
 * are stored on the server and never change, a new sensor takes the next number.
 */
export const SensorType = {
    InternalTemperature: 1,
    ExternalTemperature: 2,
    Humidity: 3,
    Co2: 4,
};
/** Translation key (`common:labels.*`) of the name of each sensor. */
const SENSOR_LABEL_KEYS = {
    [SensorType.InternalTemperature]: "common:labels.internalTemperature",
    [SensorType.ExternalTemperature]: "common:labels.externalTemperature",
    [SensorType.Humidity]: "common:labels.humidity",
    [SensorType.Co2]: "common:labels.co2",
};
/** Unit written after a reading of the sensor (the temperature sensors and an unknown sensor read in °C). */
const SENSOR_UNITS = {
    [SensorType.InternalTemperature]: "°C",
    [SensorType.ExternalTemperature]: "°C",
    [SensorType.Humidity]: "%",
    [SensorType.Co2]: " ppm",
};
export const sensorUnit = (sensorType) => { var _a; return (_a = (sensorType == null ? undefined : SENSOR_UNITS[sensorType])) !== null && _a !== void 0 ? _a : "°C"; };
/**
 * Whether a sensor is switched off on the Edit Node page, so the Logging page, the reports and the dashboard leave its data out.
 * `disabledSensors` comes from the API (empty or missing hides nothing, which is also what the older node types get). The server
 * never lists the AP node's internal temperature (it cannot be switched off); a relayed sensor's may be listed.
 */
export const isSensorHidden = (disabledSensors, sensorType) => Boolean(disabledSensors === null || disabledSensors === void 0 ? void 0 : disabledSensors.includes(sensorType));
/** The label key of a sensor, or undefined for a sensor this client does not know yet. */
export const sensorLabelKey = (sensorType) => sensorType == null ? undefined : SENSOR_LABEL_KEYS[sensorType];
